export default __webpack_public_path__ + "media/images/favicon-5a543f69.svg";